import { endOfDay, startOfDay } from "date-fns";

/**
 * The 'from' property represents the start date at the beginning of the day (00:00:00).
 * The 'to' property represents the end date at the end of the day (23:59:59).
 */
export function RoundDateRangeToFullDays(
  start: Date | undefined,
  end: Date | undefined
) {
  if (!start || !end) return undefined;
  return {
    from: startOfDay(start),
    to: endOfDay(end)
  };
}
